/**
 * KA-49 §4.1 — luật dải trạng thái host NEMA (hàm THUẦN — `kiem-ka49` nhập thẳng).
 *   Bước 0..4 = `host_status.state`. Host vắng > 75 s (máy chủ tính `matLienLac`) ⇒ xám "Mất tin host".
 *   Chưa từng có tin / chưa biết ⇒ xám "Chưa có tin host" — không đoán bước (luật số 0).
 */
export const BUOC_HOST = ['Khởi động', 'Chờ RIIM', 'Mạng lên', 'Mạng OK', 'Đang quét'] as const;

export function trangThaiDaiHost(h: { state: number | null; matLienLac: boolean | null; status_at: string | null } | null):
  { xam: true; cau: string } | { xam: false; buoc: number } {
  if (!h || h.status_at === null || h.matLienLac === null) return { xam: true, cau: 'Chưa có tin host' };
  if (h.matLienLac) return { xam: true, cau: 'Mất tin host' };
  if (h.state === null || !Number.isInteger(h.state) || h.state < 0 || h.state > 4) return { xam: true, cau: 'Host chưa báo bước' };
  return { xam: false, buoc: h.state };
}
